import React, { ChangeEvent, useEffect, useState } from 'react'
import { useStore } from 'effector-react'
import {
  $promoCode,
  getPromoCode,
  promoCodeMounted,
  setPromoCode,
  submitEditPromoCode,
} from './model'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CDatePicker,
  CForm,
  CFormCheck,
  CFormInput,
  CRow,
  CSpinner,
} from '@coreui/react-pro'

const generateCode = () => {
  const list = 'ABCDEFGHIJKLMNPQRSTUVWXYZ0123456789'
  var res = ''
  for (var i = 0; i < 6; i++) {
    var rnd = Math.floor(Math.random() * list.length)
    res = res + list.charAt(rnd)
  }
  return res
}

export const EditPromoCode: React.FC = () => {
  const promoCode = useStore($promoCode)
  const promoCodeLoading = useStore(getPromoCode.pending)

  const [date, setDate] = useState('')
  const [validated, setValidated] = useState(false)

  const handleChange = (event: {
    currentTarget: { name: any; type: string; checked?: any; value: any }
  }) => {
    const value =
      event.currentTarget.type === 'checkbox'
        ? event.currentTarget.checked
        : event.currentTarget.value

    setPromoCode({
      ...promoCode,
      [event.currentTarget.name]: value,
    })
  }

  useEffect(() => {
    promoCodeMounted()
  }, [])

  useEffect(() => {
    if (promoCode.expiresAt) {
      setDate(promoCode.expiresAt)
    }
  }, [promoCode.expiresAt])

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const form = event.currentTarget

    if (!form.checkValidity()) {
      event.preventDefault()
      event.stopPropagation()
    } else {
      submitEditPromoCode({
        ...promoCode,
        bonusPercent: Number(promoCode.bonusPercent),
        expiresAt: date,
      })
      event.preventDefault()
      event.stopPropagation()
    }
    setValidated(true)
  }

  if (promoCodeLoading) {
    return <CSpinner color="primary" />
  }

  return (
    <CCard>
      <CCardHeader className="d-sm-flex justify-content-between align-items-center">
        <strong>Edit promo code</strong>
      </CCardHeader>
      <CCardBody>
        <CForm noValidate validated={validated} onSubmit={handleSubmit}>
          <CRow className="mb-3">
            <CCol sm={4}>
              <CFormInput
                type="number"
                name="bonusPercent"
                value={promoCode.bonusPercent}
                onChange={handleChange}
                label="Bonus % (value should be between 30 and 100)"
                min={30}
                max={100}
                required
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol sm={4}>
              <CDatePicker
                date={promoCode.expiresAt}
                label="Expires at"
                locale="en-US"
                onDateChange={(date) => {
                  if (date) {
                    setDate(date.toISOString().replace('T', ' ').split('.')[0])
                  }
                }}
                required
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol sm={4}>
              <CFormCheck
                name="isDisabled"
                checked={promoCode.isDisabled}
                onChange={handleChange}
                label="Disable"
              />
            </CCol>
          </CRow>
          <CButton className="mb-3" type="submit">
            Edit
          </CButton>
        </CForm>
      </CCardBody>
    </CCard>
  )
}
